import { render } from "./ForgotPasswordForm.vue?vue&type=template&id=30502ad0&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=30502ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30502ad0"]])

export default __exports__